import { Component, Input, OnChanges } from '@angular/core';
import { ICWQuestionBase } from '../../../../../../../Common/model/cwquestion';
import { DialogService } from '../../../dialog/service/dialog.service';

@Component({
  selector: 'app-show-contained-image',
  templateUrl: './show-contained-image.component.html',
  styleUrls: ['show-contained-image.component.scss'],
})
export class ShowContainedImageComponent implements OnChanges {
  @Input()
  question: ICWQuestionBase;
  imageLoaded = false;
  imageFailedToLoad = false;
  constructor(private dialogService: DialogService) {}

  ngOnChanges(changes: any): void {
    if (changes.question) {
      this.imageLoaded = false;
      this.imageFailedToLoad = false;
    }
  }
  onImageLoaded() {
    this.imageLoaded = true;
  }
  onImageFailedToLoad() {
    this.imageFailedToLoad = true;
  }
  async onShowLargeImage() {
    await this.dialogService.showLargeImage(this.question);
  }
}
